import React, { Component } from 'react';

export default class Display_Mp_Cell_Meter extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let font_size = (0.1) * this.props.cell_width;

		let pointInfo = this.props.point_info;

		let meterValue = null;
		let unitValue = null;
		let sMeterValue = null;
		let sMeterSubUnitValue = null;

		if (pointInfo.hasOwnProperty('meter')) {
			meterValue = pointInfo.meter;
		}

		if (pointInfo.hasOwnProperty('unit')) {
			unitValue = pointInfo.unit;
		}

		if (pointInfo.hasOwnProperty('value')) {
			sMeterValue = pointInfo.value;
		}

		if (pointInfo.hasOwnProperty('sub_unit')) {
			sMeterSubUnitValue = pointInfo.sub_unit;
		}

		return (
			<div>
				<div>
					<span style={{ fontSize: font_size, display: meterValue == null ? 'none' : 'inline-block', whiteSpace: 'nowrap' }}>{meterValue + unitValue}</span>
				</div>

				<div style={{ display: pointInfo.type == 'SMeter' ? 'inline-block' : 'none' }}>
					<span style={{ fontSize: font_size, display: sMeterValue == null ? 'none' : 'inline-block', whiteSpace: 'nowrap' }}>{sMeterValue + sMeterSubUnitValue}</span>
				</div>
			</div>
		)
	}
}